module.exports = __webpack_public_path__ + "images/aixam_small52c7c0b6967b51950138906e70504b43.png";